import React, { Component, Fragment } from 'react';

import styled from 'styled-components';

import SubItem from '../molecules/FooterSubItem';
import Title from '../molecules/FooterMenuItemTitle';

import { getUrl } from '@utils/origin';
import { toggleOneTrustInfoDisplay } from '@utils/onetrust';

import { FooterContent } from '@shared/interfaces/footer-content';

type FooterMenuItemProps = {
  name: string;
  item: FooterContent;
  isLoadingCountry: boolean;
  isChinaLocation: boolean;
};

class FooterMenuItem extends Component<FooterMenuItemProps> {
  handleCookieClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    toggleOneTrustInfoDisplay(event);
  };

  renderTitleExtended = ({ title }) =>
    title.link !== '#' ? (
      <TitleExtend href={title.link} title={title.name} />
    ) : (
      <TitleExtend title={title.name} />
    );

  render() {
    const { item, isChinaLocation } = this.props;

    return (
      <Fragment>
        {this.renderTitleExtended(item)}
        <List>
          {item.items
            .filter(({ id }) => !(isChinaLocation && id === 'cookie'))
            .map(({ id, link, name }) => (
              <SubItem
                key={id}
                href={getUrl(link, id)}
                name={name}
                onClick={id === 'cookie' ? this.handleCookieClick : undefined}
              />
            ))}
        </List>
      </Fragment>
    );
  }
}

export default FooterMenuItem;

const List = styled.ul`
  display: flex;
  flex-flow: column;

  height: 100%;
`;

const TitleExtend = styled(Title)`
  margin-bottom: 0.75em;
`;
